import React, { useEffect, useState } from 'react'
import Modal from "components/Modal";
import { actionsType } from 'config/constants';
import PubSub from 'services/PubSub/';
import FormUpdateClient from './FormClientUpdate/index';
import NewRelicService from 'services/NewRelic'
import style from './style.scss';//NOSONAR

let action = [];
const ModalClientUpdate = () => {

    const [payload, setPayload] = useState(null);

    useEffect(() => {
        action.push(PubSub.register(actionsType.MODAL.UPDATE_CLIENT_OPEN, _openInfo));

        return function cleanup() {
            action.map(token => PubSub.unregister(token));
            action = [];
        }
    }, []);

    const _openInfo = (paylo) => {
        NewRelicService.sendPageAction({
            action: 'updateClientOpen'
        })
        setPayload(null);
        setTimeout(()=> {
            setPayload({...paylo});
        }, 1);
    }


    return (
        <Modal customClass='modal-add-cards' actionOpen={actionsType.MODAL.UPDATE_CLIENT_OPEN} actionClose={actionsType.MODAL.UPDATE_CLIENT_CLOSE}>
            {payload && <FormUpdateClient payload={payload}/>}
        </Modal>
    )
}

export default ModalClientUpdate;
